export enum NotificationType {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    MESSAGE = 'MESSAGE',
    WARNING = 'WARNING'
}
